const PERIODS = {
  ONE_MONTH: {
    VALUE: 1,
    LABEL: 'periods.oneMonth',
  },
  THREE_MONTHS: {
    VALUE: 3,
    LABEL: 'periods.threeMonth',
  },
  SIX_MONTHS: {
    VALUE: 6,
    LABEL: 'periods.sixMonth',
  },
  TWELVE_MONTHS: {
    VALUE: 12,
    LABEL: 'periods.twelveMonth',
  },
};

export default PERIODS;
